module.exports = __webpack_public_path__ + "static/media/deskpro.73aa2b9b.svg";